
import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import '@/components/ProductInfo/index.scss'
import SectionCom from '@/components/MeterialInfo/section.vue'
@Component({
  components: {
    SectionCom
  },
  filters:{}
})
export default class Test extends Vue {
  
  /// props
  @Prop() private customDcps!: Array<any>

  @Prop({default: ''}) private landingInfo!: any
  @Prop({default: () => {
    return []
  }}) private additionDcuList!: Array<any>
  
  /// data
  private data: Object = {}
  
  /// provide data
  @Provide() provideData: Object = {}
  
  // computed
  private get infos(): Array<any> {
      return Array<any>()
  }

  private get records(): Array<any> {
    // let {}
    return []
  }
  private get headTitle(): any {
    if(this.landingInfo && this.landingInfo.customizedLp){
      let {custom} = this.landingInfo.activity
      return custom.textplain_011 || this.$t('app.meterial_head')
    }
    return this.$t('app.meterial_head')
  }

  public viewDetail(item: any, index: number) {
    this.$store.state.recordAdditionDcu = this.additionDcuList[index]
    this.$store.state.record = item
    this.$router.push({name: 'DcpDetail', query: {type: 'meterial'}})
  }

  private get meterialCountTitle(): string {
    if(this.customDcps && this.customDcps.length > 1){
      return `${this.customDcps.length}`+ this.$t('app.custom_records_multi')
    }else{
      return `${this.customDcps.length}`+ this.$t('app.custom_records_single')
    }
  }
  
  /// lifecycle
  created() {
    
  }
  
  mounted() {
    
  }
  
  /// methods
  public methodOne(params: any): void {
    
  }
  /// watch methods
  @Watch('newList', { immediate: true, deep: true })
  onArrayChanged(newVal: any, oldVal: any) {
    
  }
}
